import { render, staticRenderFns } from "./ExamSumary.vue?vue&type=template&id=2ef0c760&scoped=true&"
import script from "./ExamSumary.vue?vue&type=script&lang=js&"
export * from "./ExamSumary.vue?vue&type=script&lang=js&"
import style0 from "./ExamSumary.vue?vue&type=style&index=0&id=2ef0c760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0c760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VSimpleTable})
